<template>
  <div>
    <va-inner-loading :loading="loading">
      <callbacks-table
        class="mb-4"
        :callbacks="callbacks"
        :loading="loading"
        @refresh="fetchCallbacks"
      />
    </va-inner-loading>
  </div>
</template>

<script>
import api from "@/api/axios";
import CallbacksTable from "../../components/callbacks/callbacks-table.vue";

export default {
  name: "Callbacks",
  components: {
    CallbacksTable,
  },
  data() {
    return {
      callbacks: [],
      loading: false,
    };
  },
  created() {
    this.fetchCallbacks();
  },
  methods: {
    async fetchCallbacks() {
      this.loading = true;
      try {
        const response = await api.get("/admin/callbacks", {
          params: {
            all: 1,
          },
        });
        this.callbacks = response.data.data || response.data || [];
      } catch (error) {
        console.error("Ошибка загрузки заявок на обратный звонок:", error);
        this.callbacks = [];
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style></style>
